import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Select } from 'antd';
import isEqual from 'lodash/isEqual';

import ModalFooter from '../../../../../../../components/modalfooter';

const Option = Select.Option;


class WorkflowNodeForm extends Component {
    constructor() {
        super();
        this.state = {
            workflow_nodes: null,
            data_error: {
                workflow: false,
                node: false,
            }
        };
    }

    componentDidMount() {
        const { workflow_node_details } = this.props;
        if (workflow_node_details && workflow_node_details.nextWId) {
            this.setWorkflowNodes();
        }
    }

    componentDidUpdate(prevProps) {
        const { workflow_node_details } = this.props;
        if (workflow_node_details && prevProps.workflow_node_details.nextWId !== workflow_node_details.nextWId) {
            this.setWorkflowNodes();
        }
        if(workflow_node_details && !isEqual(workflow_node_details, prevProps.workflow_node_details)){
            this.checkDataFieldError();
        }
    }

    setWorkflowNodes = () => {
        const { workflow_node_details, workflows } = this.props;
        const selected_workflow = workflows.find((workflow) => workflow.wid === workflow_node_details.nextWId);
        this.setState({ workflow_nodes: selected_workflow.nodes ? selected_workflow.nodes : null });
    };

    checkDataFieldError = (callback) => {
        const { workflow_node_details } = this.props;

        this.setState({
            data_error: {
                workflow: !(workflow_node_details && workflow_node_details.nextWId && workflow_node_details.nextWId !== undefined),
                node: !(workflow_node_details && workflow_node_details.nextNodeId && workflow_node_details.nextNodeId !== undefined)
            }
        }, () => { if (callback) callback();});
    };

    hasDataFieldError = () => {
        const { workflow, node } = this.state.data_error;
        return (workflow || node);
    };

    handleSubmitClick = () => {
        this.checkDataFieldError(() => {
            if (!this.hasDataFieldError()) {
                this.props.handleOkClick();
            }
        });
    };


    render() {
        const { workflows, workflow_node_details, loading, button_ok_text, onChangeWorkflow, onChangeWorkflowNode, handleCancelClick } = this.props;
        const { workflow_nodes, data_error } = this.state;

        return (
            <div className="ori-full-parent-height ori-overflow-auto">
                <div className="ori-tb-pad-10 ori-lr-pad-15">
                    <div className="ori-relative ori-tb-pad-7">
                        <p className="ori-b-mrgn-5">Workflow</p>
                        <Select showSearch className={classNames("ori-full-width",{"ori-select-border-warning": data_error.workflow})} dropdownClassName="ori-zindex-99999" placeholder="Select Workflow" optionFilterProp="children" filterOption={(input, option) => option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} value={workflow_node_details.nextWId} onChange={onChangeWorkflow} >
                            {
                                workflows.map((workflow) => {
                                    return (
                                        <Option key={workflow.wid} value={workflow.wid}>{workflow.name}</Option>
                                    );
                                })
                            }
                        </Select>
                        {
                            data_error.workflow &&
                            <p className="ori-absolute ori-align-bottom-neg-8 ori-font-warning ori-font-xs">Workflow is required.</p>
                        }
                    </div>
                    {
                        workflow_nodes &&
                        <div className="ori-relative ori-tb-pad-7">
                            <p className="ori-b-mrgn-5 ori-capitalize-first">Workflow Node</p>
                            <Select showSearch className={classNames("ori-full-width", { "ori-select-border-warning": data_error.node })} dropdownClassName="ori-zindex-99999" placeholder="Select Workflow's Node" optionFilterProp="children" filterOption={(input, option) => option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} value={workflow_node_details.nextNodeId} onChange={onChangeWorkflowNode} >
                                {
                                    workflow_nodes.map((node) => {
                                        return (
                                            <Option key={node.nodeId} value={node.nodeId}>{node.name}</Option>
                                        );
                                    })
                                }
                            </Select>
                            {
                                data_error.node &&
                                <p className="ori-absolute ori-align-bottom-neg-8 ori-font-warning ori-font-xs">Workflow Node is required.</p>
                            }
                        </div>
                    }
                </div>
                <div className="ori-absolute ori-full-width ori-align-bottom ori-b-pad-5 ori-align-left">
                    <ModalFooter loading={loading} button_ok_text={button_ok_text} handleCancelClick={handleCancelClick} handleOkClick={this.handleSubmitClick} capsule_button />
                </div>
            </div>
        );
    }
}

WorkflowNodeForm.propTypes = {
    workflows: PropTypes.array.isRequired,
    workflow_node_details: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onChangeWorkflow: PropTypes.func,
    onChangeWorkflowNode: PropTypes.func,
    handleCancelClick: PropTypes.func,
    handleOkClick: PropTypes.func,
    button_ok_text: PropTypes.string,
};

export default WorkflowNodeForm;


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/workflows/workflowdiagram/workflownodeform/index.js